// src/App.jsx
import React from "react";
import { useEffect, useState } from "react";
import img1 from "../Assets/1.png"

function Publications() {
  //let count = 1;


  const patents = [
    {
      sno: 1,
      authors: "Lakhani Piyush , Kumar Amit, Mundra Rupinder Singh, Prof. Navin Kumar",
      title: "System and method for computing a capillary refill time and a quality of nail",
      applicationsNo: "201911001668 (Patent No.563666)",
      status: "Granted (25_March_2025)",
    },
    {
      sno: 2,
      authors: "Krashn Kumar Dwivedi,Lakhani Piyush , Dr. Sachin Kumar , Prof. Navin Kumar",
      title: "Apparatus for mechanical Testing of Biological Tissues",
      applicationsNo: "202111012872 (Patent No.560678)",
      status: "Granted (19_Feb_2025)",
    },
    {
      sno: 3,
      authors: "Lakhani Piyush, Krashn Kumar Dwivedi, Prof. Navin Kumar",
      title: "An Apparatus For Measuring In-Vivo Mechanical Properties of Soft Material And Assessment Of Skin Turgor.",
      applicationsNo: "202011014417",
      status: "Granted",
    }, {
      sno: 4,
      authors: "Mr. Piyush Manharbhai Lakhani, Mr. Rohan Panth & Prof. Navin Kumar",
      title: "An Apparatus For Mechanical Characterisation Of A Soft Tissue",
      applicationsNo: "201911007207",
      status: "Granted",
    }, {
      sno: 5,
      authors: "Prof. Navin Kumar, Dr. Rakesh Das, Mr. Ramnesh Yadav, Mr. Piyush Uniyal, Mr. Praveer Shihota, Prof. Bharat Bhushan",
      title: "A Painless Micro Syringe-Needle System For Drug Delivery",
      applicationsNo: "201911012456",
      status: "Granted",
    }, {
      sno: 6,
      authors: "Mr. Praveer Sihota, Mr. Ram Naresh Yadav, Prof. Navin Kumar, Dr. Vishwajeet Mehandia, Dr. Sanjay Kumar Bhadada & Vandana Dhiman",
      title: "Method For Analyzing A Health Status On a Health Measurement Scale",
      applicationsNo: "202011006130",
      status: "Granted",
    }, {
      sno: 7,
      authors: "Mr. Piyush Manharbhai Lakhani, Mr. Krashan K Dwivedi & Prof. Navin Kumar",
      title: "An Apparatus For Measuring In-Vivo Mechanical Properties Of Soft Material And Assessment Of Skin Turgor",
      applicationsNo: "202011014417",
      status: "Granted",
    }, {
      sno: 8,
      authors: "Mathew Joseph, Prof. Navin Kumar, Manu Sharma, Sukesha Sharma",
      title: "Automated artificial breathing device",
      applicationsNo: "201811020643",
      status: "Granted",
    },
  ];

  const publications = [
    {
      year: 2009,
      publications: [
        {
          authors: "Meena S., Kumar N., Singh S.P., Nakra B.C., Vibration control of plate by active and passive constrained layer damping, (2009) Advances in Vibration Engineering, 8 (4), pp. 345-356.[IF=2.333]",
        },
        {
          authors: "Kumar N., Singh S.P., Vibration and damping characteristics of beams with active constrained layer treatments under parametric variations, (2009) Materials and Design, 30 (10), pp. 4162-4174. [IF = 9.417]",
        },

      ]
    },
    {
      year: 2010,
      publications: [
        {
          authors: "Kumar N., Singh S.P., Experimental study on vibration and damping of curved panel treated with constrained viscoelastic layer, (2010) Composite Structures, 92 (2), pp. 233-243. [IF = 6.603]",
        },

      ]
    },
    {
      year: 2012,
      publications: [
        {
          authors: "Kumar N., Singh S.P., Vibration control of curved panel using smart damping, (2012) Mechanical Systems and Signal Processing, 30, pp. 232-247. [IF=8.934]",
        },
        {
          authors: "Kumar N., Pochiraju K., Dynamics of virial stress in gold lattice after crack initiation, (2012) Proceedings of the Institution of Mechanical Engineers, Part C: Journal of Mechanical Engineering Science, 226 (2), pp. 359-366. [IF = 1.762]",
        }

      ]
    },
    {
      year: 2013,
      publications: [
        {
          authors: "Jindal P., Goyal M., Kumar N., Modeling composites of multi-walled carbon nanotubes in polycarbonate, (2013) International Journal for Computational Methods in Engineering Science and Mechanics, 14 (6), pp. 542-551."
        },
        {
          authors: "Sharma S., Chandra R., Kumar P., Kumar N., Molecular dynamics simulation of polymer/carbon nanotube composites, (2013) International Journal of Nanomechanics Science and Technology, 4 (1), pp. 29-45."
        },
        {
          authors: "Sharma S., Chandra R., Kumar P., Kumar N., Molecular dynamics simulation of carbon nanotubes, (2013) International Journal of Nano mechanics Science and Technology, 4 (1), pp. 1-27."
        }
      ]
    },
    {
      year: 2014,
      publications: [
        {
          authors: "Singh S., Kumar N., Combined rotor fault diagnosis in rotating machinery using empirical mode decomposition, (2014) Journal of Mechanical Science and Technology, 28 (12), pp. 4869-4876. [IF = 1.810]"
        },
        {
          authors: "Sharma, S., Chandra, R., Kumar, P., Kumar, N., Effect of Stone-Wales and vacancy defects on elastic moduli of carbon nanotubes and their composites using molecular dynamics simulation, (2014) Computational Materials Science, 86, pp. 1-8. [IF = 3.572]"
        },
        {
          authors: "Jindal P., Goyal M., Kumar N., Role of carbon nanotubes in polycarbonate composites for modification in hardness, (2014) International Journal of Nanoelectronics and Materials, 7 (2), pp. 85-91."
        },
        {
          authors: "Saini, K., Kumar, N., Torsional deformation behavior of cracked gold nano-wires, (2014) Acta Mechanica, 225 (3), pp. 687-700. [IF = 2.698]"
        },
        {
          authors: "Jindal P., Goyal M., Kumar N., Mechanical characterization of multiwalled carbon nanotubes-polycarbonate composites, (2014) Materials and Design, 54, pp. 864-868. [IF = 9.417]"
        },
      ]
    },
    {
      year: 2015,
      publications: [
        {
          authors: "Sharma S., Vig R., Kumar N., Active vibration control: Considering effect of electric field on coefficients of PZT patches, (2015) Smart Structures and Systems, 16 (6), pp. 1091-1105. [IF = 4.26]"
        },
        {
          authors: "Singh S., Kumar N., Rotor faults diagnosis using artificial neural networks and support vector machines, (2015) International Journal of Acoustics and Vibrations, 20 (4), pp. 153-159. [IF = 0.872]"
        },
        {
          authors: "Sukesha, Vig R., Kumar N., Effect of Electric Field and Temperature on Dielectric Constant and Piezoelectric Coefficient of Piezoelectric Materials: A Review, (2015) Integrated Ferroelectrics, 167 (1), pp. 154-175. [IF = 0.836]"
        },
        {
          authors: "Singh, S., Kumar, N., Rotor faults diagnosis using artificial neural networks and support vector machines, (2015) International Journal of Acoustics and Vibrations, 20 (3), pp. 153-159. [IF = 0.872]"
        },
        {
          authors: "Saini K., Kumar N., Mechanical response of collagen molecule under hydrostatic compression, (2015) Materials Science and Engineering C, 49, pp. 720-726. [IF = 7.328]"
        },
        {
          authors: "Sharma S., Chandra R., Kumar P., Kuma N., Experimental investigation of the dynamic properties of fiber-reinforced composites, (2015) Composites: Mechanics, Computations, Applications, 6 (4), pp. 307-320."
        },
        {
          authors: "Sharma S., Chandra R., Kumar P., Kumar N., Molecular dynamics simulation of polymer/carbon nanotube composites, (2015) Acta Mechanica Solida Sinica, 28 (4), pp. 409-419. [IF = 2.187]"
        },
        {
          authors: "Sharma S., Chandra R., Kumar P., Kumar N., Thermo-mechanical characterization of multi-walled carbon nanotube reinforced polycarbonate composites: A molecular dynamics approach, (2015) Comptes Rendus – Mecanique, 343 (5-6), pp. 371-396. [IF = 2.076]"
        },
        {
          authors: "Brown P.S., Talbot E.L., Wood T.J., Egan M.J., Wu J.J., Saini K., Kumar N., Bain C.D., Badyal J.P.S., Controlling picolitre droplet impact dynamics by tailoring the solid subsurface, (2015) Colloids and Surfaces A: Physicochemical and Engineering Aspects, 481, pp. 215-221. [IF = 5.518]"
        },
        {
          authors: "Tiwari A.K., Patel A.R., Kumar N., Investigation of strain rate on residual stress distribution, (2015) Materials and Design, 65, pp. 1041-1047. [IF = 9.417]"
        }
      ]
    },
    {
      year: 2016,
      publications: [
        {
          authors: "Jindal P., Jyoti J., Kumar N., Mechanical characterisation of ABS/MWCNT composites under static and dynamic loading conditions, (2016) Journal of Mechanical Engineering and Sciences, 10 (3), pp. 2288-2299. [IF = 1.495]"
        },
        {
          authors: "Sarabi B.K., Sharma M., Kaur D., Kumar N., A novel technique for generating desired vibrations in structure, (2016) Integrated Ferroelectrics, 176 (1), pp. 236-250. [IF = 0.836]"
        },
        {
          authors: "Sharma S., Vig R., Kumar N., Temperature compensation in a smart structure by application of DC bias on piezoelectric patches, (2016) Journal of Intelligent Material Systems and Structures, 27 (18), pp. 2524-2535. [IF = 2.774]"
        },
        {
          authors: "Sharma S., Vig R., Kumar N., Finite element modeling of smart piezo structure: considering dependence of piezoelectric coeﬃcients on electric field, (2016) Mechanics Based Design of Structures and Machines, 44 (4), pp. 372-383. [IF = 4.09]"
        },
        {
          authors: "Sukesha Y., Vig R., Kumar N., Variation of piezoelectric coefficient and permittivity of piezo-actuator with electric field in AVC experiments, (2016) Integrated Ferroelectrics, 502 (1), pp. 170-186. [IF = 0.836]"
        },
        {
          authors: "Sharma S., Chandra R., Kumar P., Kumar N., Mechanical Properties of Carbon Nanofiber Reinforced Polymer Composites-Molecular Dynamics Approach, (2016) JOM, 68 (6), pp. 1717-1727. [IF = 2.973]"
        },
        {
          authors: "Sharma S., Chandra R., Kumar P., Kumar N., Molecular level analysis of carbon nanofiber reinforced polymer composites, (2016) Journal of Composite Materials, 50 (13), pp. 1787-1804. [IF = 3.191]"
        }
      ]
    },
    {
      year: 2017,
      publications: [
        {
          authors: "Sarabi B.K., Sharma M., Kaur D., Kumar N., An Optimal Control Based Technique for Generating Desired Vibrations in a Structure, (2017) Iranian Journal of Science and Technology – Transactions of Electrical Engineering, 41 (3), pp. 219-228. [IF = 2.25]"
        },
        {
          authors: "Singh S., Kumar N., Detection of Bearing Faults in Mechanical Systems Using Stator Current Monitoring, (2017) IEEE Transactions on Industrial Informatics, 13 (3), art. no. 7790896, pp. 1341-1349. [IF = 10.215]"
        },
        {
          authors: "Jindal P., Yadav R.N., Kumar N., Dynamic mechanical characterization of PC/MWCNT composites under variable temperature conditions, (2017) Iranian Polymer Journal (English Edition), 26 (6), pp. 445-452. [IF = 1.899]"
        },
        {
          authors: "Yadav J.A., Khomane K.S., Modi S.R., Ugale B., Yadav R.N., Nagaraja C.M., Kumar N., Bansal A.K., Correlating Single Crystal Structure, Nanomechanical, and Bulk Compaction Behavior of Febuxostat Polymorphs, (2017) Molecular Pharmaceutics, 14 (3), pp. 866-874. [IF = 5.364]"
        },
        {
          authors: "Jain T., Sheokand S., Modi S.R., Ugale B., Yadav R.N., Kumar N., Nagaraja C.M., Bansal A.K., Effect of differential surface anisotropy on performance of two plate shaped crystals of aspirin form I, (2017) European Journal of Pharmaceutical Sciences, 99, pp. 318-327. [IF = 5.112]"
        },
        {
          authors: "Das R., Kumar A., Patel A., Vijay S., Saurabh S., Kumar N., Biomechanical characterization of spider webs, (2017) Journal of the Mechanical Behavior of Biomedical Materials, 67, pp. 101-109. [IF = 4.042]"
        }
      ]
    },
    {
      year: 2018,
      publications: [
        {
          authors: "Das R., Yadav R.N., Sihota P., Uniyal P., Kumar N., Bhushan B., Biomechanical Evaluation of Wasp and Honeybee Stingers, (2018) Scientific Reports, 8 (1), art. no. 14945. [IF = 4.996]"
        },
        {
          authors: "Yadav J.P.A., Yadav B., Kumar N., Bansal A.K., Jain S., Revealing the Role of Structural Features in Bulk Mechanical Performance of Ternary Molecular Solids of Isoniazid, (2018) Molecular Pharmaceutics, 15 (11), pp. 5252-5262. [IF = 5.364]"
        },
        {
          authors: "Sapra G., Kumar P., Kumar N., Vig R., Sharma M., Effect of processing conditions on the electrical resistance of MWCNT/epoxy nanocomposite-based strain sensors, (2018) Journal of Materials Science: Materials in Electronics, 29 (22), pp. 19264-19277. [IF = 2.478]"
        },
        {
          authors: "Gurera D., Bhushan B., Kumar N., Lessons from mosquitoes’ painless piercing, (2018) Journal of the Mechanical Behavior of Biomedical Materials, 84, pp. 178-187. [IF = 4.042]"
        },
        {
          authors: "Bansal S.A., Singh A.P., Kumar A., Kumar S., Kumar N., Goswamy J.K., Improved mechanical performance of bisphenol-A graphene-oxide nano-composites, (2018) Journal of Composite Materials, 52 (16), pp. 2179-2188. [IF = 3.191]"
        },
        {
          authors: "Tiwari A.K., Kumar N., Establishing the relationship between loading parameters and bone adaptation, (2018) Medical Engineering and Physics, 56, pp. 16-26. [IF = 2.356]"
        },
        {
          authors: "Sharma S., Kumar P., Kumar N., Chandra R., Graphene/carbon nanotube-reinforced nickel composites: A molecular dynamics study, (2018) Composites: Mechanics, Computations, Applications, 9 (3), pp. 247-268."
        }
      ]
    },
    {
      year: 2019,
      publications: [
        {
          authors: "Sihota P., Yadav R.N., Dhiman V., Bhadada S.K., Mehandia V., Kumar N., Investigation of diabetic patient’s fingernail quality to monitor type 2 diabetes induced tissue damage, (2019) Scientific Reports, 9 (1), art. no. 3193. [IF = 4.996]"
        },
        {
          authors: "Sood P., Sharma M., Sharma S., Kumar N., A novel strategy for effectively implementing a typical AVC scheme using finite element model updating, (2019) Mechanics Based Design of Structures and Machines, 47 (6), pp. 740-752. [IF = 4.09]"
        },
        {
          authors: "Tiwari A.K., Kumar A., Kumar N., Prakash C., Investigation on micro-residual stress distribution near hole using nanoindentation: Effect of drilling speed, (2019) Measurement and Control (United Kingdom), 52 (9-10), pp. 1252-1263. [IF = 1.97]"
        },
        {
          authors: "Yadav J.P., Yadav R.N., Sihota P., Chen H., Wang C., Sun C.C., Kumar N., Bansal A., Jain S., Single-Crystal Plasticity Defies Bulk-Phase Mechanics in Isoniazid Cocrystals with Analogous Coformers, (2019) Crystal Growth and Design, 19 (8), pp. 4465-4475. [IF = 4.01]"
        },
        {
          authors: "Saini K., Discher D., Kumar N., Static and time-dependent mechanical response of organic matrix of bone, (2019) Journal of the Mechanical Behavior of Biomedical Materials, 91, pp. 315-325. [IF = 4.042]"
        },
        {
          authors: "Kumar A., Kumar N., Das R., Lakhani P., Bhushan B., In vivo structural dynamic analysis of the dragonfly wing: The effect of stigma as its modulator, (2019) Philosophical Transactions of the Royal Society A: Mathematical, Physical and Engineering Sciences, 377 (2150), art. no. 20190132. [IF = 4.226]"
        },
        {
          authors: "Jyoti J., Kumar A., Lakhani P., Kumar N., Bhushan B., Structural properties and their influence on the prey retention in the spider web, (2019) Philosophical Transactions of the Royal Society A: Mathematical, Physical and Engineering Sciences, 377 (2138), art. no. 20180271. [IF = 4.226]"
        }
      ]
    },
    {
      year: 2020,
      publications: [
        {
          authors: "Dwivedi K.K., Lakhani P., Kumar S., Kumar N., Frequency dependent inelastic response of collagen architecture of pig dermis under cyclic tensile loading: An experimental study, (2020) Journal of the Mechanical Behavior of Biomedical Materials, 112, art. no. 104030. [IF = 4.042]"
        },
        {
          authors: "Sihota P., Yadav R.N., Poleboina S., Mehandia V., Bhadada S.K., Tikoo K., Kumar N., Development of HFD-Fed/Low-Dose STZ-Treated Female Sprague-Dawley Rat Model to Investigate Diabetic Bone Fragility at Different Organization Levels, (2020) JBMR Plus, 4 (10), art. no. e10379. [IF = 3.503]"
        },
        {
          authors: "Dounkal M.K., Bhan R.K., Kumar N., A new improved vertical comb type differential capacitive sensing micro accelerometer using silicon-on-insulator wafer technology, (2020) Journal of Micromechanics and Microengineering, 30 (10), art. no. 105008. [IF = 2.282]"
        },
        {
          authors: "Sharma A., Mulaveesala R., Dua G., Kumar N., Linear frequency modulated thermal wave imaging for estimation of osteoporosis: An analytical approach, (2020) Electronics Letters, 56 (19), pp. 1007-1010. [IF = 1.343]"
        },
        {
          authors: "Dwivedi K.K., Lakhani P., Kumar S., Kumar N., The Effect of Strain Rate on the Stress Relaxation of the Pig Dermis: A Hyper-Viscoelastic Approach, (2020) Journal of Biomechanical Engineering, 142 (9), art. no. 091006. [IF = 2.097]"
        },
        {
          authors: "Soni A., Kumar S., Kumar N., Effect of parametric uncertainties on fracture behavior of cortical bone using XIGA, (2020) Engineering Fracture Mechanics, 233, art. no. 107079. [IF = 4.406]"
        },
        {
          authors: "Kale D.P., Puri V., Kumar A., Kumar N., Bansal A.K., The role of co-crystallization-mediated altered crystallographic properties on the tabletability of rivaroxaban and malonic acid, (2020) International Journal of Pharmaceutics, 12 (6), art. no. 546, pp. 1-22. [IF = 6.51]"
        },
        {
          authors: "Lakhani P., Dwivedi K.K., Kumar N., Directional dependent variation in mechanical properties of planar anisotropic porcine skin tissue, (2020) Journal of the Mechanical Behavior of Biomedical Materials, 104, art. no. 10369. [IF = 4.042]"
        },
        {
          authors: "Kumar N., Kumar A., Uniyal P., Ramalingaiah B., Sharma S., Goni V.G., Aggarwal S., Bhadada S.K., Bhushan B., Mimicking high strength lightweight novel structures inspired from the trabecular bone microarchitecture, (2020) Philosophical Transactions of the Royal Society A: Mathematical, Physical and Engineering Sciences, 378 (2167). [IF = 4.226]"
        },
        {
          authors: "Yadav J.P., Yadav R.N., Uniyal P., Chen H., Wang C., Sun C.C., Kumar N., Bansal A.K., Jain S., Molecular Interpretation of Mechanical Behavior in Four Basic Crystal Packing of Isoniazid with Homologous Cocrystal Formers, (2020) Crystal Growth and Design, 20 (2), pp. 832-844. [IF = 4.01]"
        },
        {
          authors: "Dounkal M.K., Bhan R.K., Kumar N., Effects of various loading on the performance of MEMS cantilever beam for in-field tuning of sensors and actuators for high temperature and harsh environment applications, (2020) Microsystem Technologies, 26 (2), pp. 377-394. [IF = 1.772]"
        },
        {
          authors: "Kumar D., Kumar N., Jindal P., Reinforcing MWCNTs to enhance viscoelastic properties of polyurethane nanocomposites by using nano DMA techniques, (2020) Journal of Thermoplastic Composite Materials. [IF = 3.33]"
        }
      ]
    },
    {

      year: 2021,
      publications: [
        {
          authors: "Lakhani P., Dwived K.K., Parashar A., Kumar N., Non-Invasive in Vivo Quantification of Directional Dependent Variation in Mechanical Properties for Human Skin, Frontiers in Bioengineering and Biotechnology, 1 October 2021 | Volume 9 | Article 749492 [IF = 5.89]"
        },
        {
          authors: "Sihota P., Pal R., Yadav R.N., Neradi D., Karn S., Goni V.G., Sharma S., Mehandia V., Bhadada S.K., Kumar N., Rao S.D., Can fingernail quality predict bone damage in Type 2 diabetes mellitus? a pilot study, PLoS ONE 16(9): e0257955 [IF = 3.24]"
        },
        {
          authors: "Sihota P., Yadav R.N., Dhaliwal R., Bose J.C., Dhiman V., Neradi D., Karn S., Sharma S., Aggarwal S., Goni V.G., Mehandia V., Vashishth D., Bhadada S.K., Kumar N., Investigation of Mechanical, Material, and Compositional Determinants of Human Trabecular Bone Quality in Type 2 Diabetes, The Journal of Clinical Endocrinology and Metabolism, 106 (5), pp. e2271-e2289. [IF = 6.134] - Highly Cited Work"
        },
        {
          authors: "Uniyal P., Sihota P., Tikoo K., Kumar N., Anatomical variation in intracortical canal network microarchitecture and its influence on bone fracture risk, Journal of the Mechanical Behavior of Biomedical Materials, 123, art. no. 104770. [IF = 4.042]"
        },
        {
          authors: "Yadav R.N., Uniyal P., Sihota P., Kumar S., Dhiman V., Goni V.G., Sahni D., Bhadada S.K., Kumar N., Effect of ageing on microstructure and fracture behavior of cortical bone as determined by experiment and Extended Finite Element Method (XFEM), Medical Engineering and Physics, 93, pp. 100-112. [IF = 2.47]"
        },
        {
          authors: "Yadav R.N., Sihota P., Uniyal P., Neradi D., Bose J.C., Dhiman V., Karn S., Sharma S., Aggarwal S., Goni V.G., Kumar S., Bhadada S.K., Kumar N., Prediction of mechanical properties of trabecular bone in patients with type 2 diabetes using damage based finite element method, Journal of Biomechanics, 123, art. no. 110495. [IF = 2.789]"
        },
        {
          authors: "Soni A., Negi A., Kumar S., Kumar N., An IGA based nonlocal gradient-enhanced damage model for failure analysis of cortical bone, Engineering Fracture Mechanics, 255, art. no. 107976. [IF = 4.406]"
        },
        {
          authors: "Agarwal G., Kumar N., Srivastava A., Highly elastic, electroconductive, immunomodulatory graphene crosslinked collagen cryogel for spinal cord regeneration, Materials Science and Engineering C, 118, art. no. 111518. [IF = 7.328]"
        },
        {
          authors: "Minhas A.S., Kankar P.K., Kumar N., Singh S., Bearing fault detection and recognition methodology based on weighted multiscale entropy approach, Mechanical Systems and Signal Processing, 147, art. no. 107073. [IF = 8.934]"
        },
        {
          authors: "Dounkal M.K., Bhan R.K., Kumar N., Stress analysis in new improved differential vertical comb capacitive micro accelerometer using SOI technology, Microsystem Technologies, 27 (8), pp. 3037-3047. [IF = 2.276]"
        },
        {
          authors: "Kiran A., Shekhar C., Sabapathy M., Mishra M., Kumar L., Kumar N., Mehandia V., Effect of serum starvation on rheology of cell monolayers, Physics of Fluids, 33 (7), art. no. 071908. [IF = 3.521]"
        },
        {
          authors: "Sharma A., Mulaveesala R., Dua G., Arora V., Kumar N., Digitized Frequency Modulated Thermal Wave Imaging for Detection and Estimation of Osteoporosis, IEEE Sensors Journal, 21 (13), art. no. 9286563, pp. 14003-14010. [IF = 3.301]"
        },
        {
          authors: "Kiran A., Kumar N., Mehandia V., Distinct Modes of Tissue Expansion in Free Versus Earlier-Confined Boundaries for More Physiological Modeling of Wound Healing, Cancer Metastasis, and Tissue Formation, ACS Omega, 6 (17), pp. 11209-11222. [IF = 4.98]"
        },
        {
          authors: "Jyoti J., Kiran A., Sandhu M., Kumar A., Singh B.P., Kumar N., Improved nanomechanical and in-vitro biocompatibility of graphene oxide-carbon nanotube hydroxyapatite hybrid composites by synergistic effect, Journal of the Mechanical Behavior of Biomedical Materials, 117, art. no. 104376. [IF = 4.042]"
        },
        {
          authors: "Singla T., Pal Singh A., Kumar S., Singh G., Kumar N., Characterization of MWCNTs-polystyrene nanocomposite-based strain sensor, Proceedings of the Institution of Mechanical Engineers, Part E: Journal of Process Mechanical Engineering, 235 (2), pp. 463-469. [IF = 1.606]"
        },
        {
          authors: "Verma D., Uniyal P., Singh D., Verma S.K., Kumar N., Balakrishnan V., Dynamic mechanical response of VO2 – UHMWPE polymer composite across the phase transition, Materials Today Communications, 26, art. no. 102003. [IF = 3.662]"
        },
        {
          authors: "Mathew J.L., Sharma M., Gawri A., Sukesha, Kumar N., Chander A., Mathew P.J., Design, development and evaluation of Artificial Breathing Capability Device (ABCD): A novel innovation for respiratory support, BMJ Innovations, 7 (1), pp. 40-46. [IF = 1.8]"
        },
        {
          authors: "Kumar R., Tiwari A.K., Tripathi D., Main R.P., Kumar N., Sihota P., Ambwani S., Sharma N.N., Anatomical variations in cortical bone surface permeability: Tibia versus femur, Journal of the Mechanical Behavior of Biomedical Materials, 113, art. no. 104122. [IF = 4.042]"
        }
      ]
    },
  {
      year: 2022,
      publications: [
        {
          authors: "Dwivedi K., Lakhani P., Sihota P., Tikoo K., Kumar S., Kumar N., The multiscale characterization and constitutive modeling of healthy and type 2 diabetes mellitus Sprague Dawley rat skin, Acta Biomaterialia. [IF=10.63]"
        },
        {
          authors: "Salunke P., Karthigeyan M., Uniyal P., Mishra K., Gupta T., Kumar N., A novel pedicle screw design with variable thread geometry: Biomechanical cadaveric study with finite element analysis, World Neurosurgery. [IF=2.104]"
        },
        {
          authors: "Joshi P., Gupta K., Uniyal P., Jana A., Banerjee A., Kumar N., Ghosh D., Srivastava M., Ray A., Khatri O.P., Cassava starch-derived aerogels as biodegradable packaging materials, Materials Chemistry and Physics, 127282. [IF=4.094]"
        },
        {
          authors: "Singh N.P., Deep S., Čerňanský A., Sehgal R.K., Singh A.P., Kumar N., Uniyal P., Kumar S., Krishan K., Patnaik R., Fossil lizards and snakes (Diapsida, Squamata) from the Late Miocene hominid locality of Haritalyangar, India, Geobios 75:41–51. [IF=2.11]"
        },
        {
          authors: "Jha A.K., Kumar N., Suresh K., Vibration Attenuation Study of Curved Panel Treated with Partially Constrained Composite Unaged and Aged NBR Elastomers, Journal of Vib. Eng. Technol. [IF=2.333]"
        },
        {
          authors: "Uniyal P., Sharma A., Kumar N., Investigation on the sensitivity of indentation devices for detection of fatigue loading induced damage in bovine cortical bone, Journal of Biomechanics. [IF=2.751]"
        },
        {
          authors: "Jha A., Kumar S., Kumar N., Enhancement in mechanical properties by addition of nano carboxyl graphene and nano silica in composite NBR elastomer, Polymer and Polymer Composites. [IF=2.0]"
        },
        {
          authors: "Jyoti J., Kumar A., Lakhani P., Structural and Vibrational Response of Artificial Spider Webs with Different Spacing, Journal of Vib. Eng. Technol. [IF=2.333]"
        },
        {
          authors: "Avinash S., Sihota P., Mursaleen M., Kumar N., Nanomechanical properties of human hair using AFM, nanoindentation, SEM and EDX, Jurnal Tribologi 31(1):46–54. [IF=1.91]"
        },
        {
          authors: "Soni A., Kumar S., Kumar N., Stochastic failure analysis of proximal femur using an isogeometric analysis based nonlocal gradient-enhanced damage model, Computer Methods and Programs in Biomedicine, 106820. [IF=7.027]"
        },
        {
          authors: "Yadav R.N., Sihota P., Neradi D., Bose J.C., Dhiman V., Karn S., Sharma S., Aggarwal S., Goni V.G., Bhadada S.K., Kumar N., Effects of type 2 diabetes on the viscoelastic behavior of human trabecular bone, Medical Engineering and Physics. [IF=2.47]"
        },
        {
          authors: "Dounkal M.K., Bhan R.K., Kumar N., Design and Simulation of Vertical Bi-Directional Fringe Field Tuning of New Improved MEMS Accelerometer Using SOI Technology for Stress Compensation, Silicon. [IF=2.941]"
        },
        {
          authors: "Sharma S., Porwal K., Kulkarni C., Pal S., Sihota P., Kumar S., Tiwari M.C., et al., Diosmin, a citrus fruit-derived phlebotonic bioflavonoid protects rats from chronic kidney disease-induced loss of bone mass and strength without deteriorating the renal function, Food & Function 13(4):2184–2199. [IF=6.317]"
        },
        {
          authors: "Singh A.K., Srivastava P.K., Kumar N., Mahajan P., A fabric tensor based small strain constitutive law for the elastoplastic behavior of snow, Mechanics of Materials. [IF=4.137]"
        },
        {
          authors: "Tikoo K., Poleboina S., Sheth V.G., Sharma N., Sihota P., Kumar N., Selenium nanoparticles stimulate osteoblast differentiation via BMP-2/MAPKs/β-catenin pathway in diabetic osteoporosis, Nanomedicine. [IF=6.096]"
        },
        {
          authors: "Wazir W.A., Sehgal R.K., Čerňanský A., Patnaik R., Kumar N., Singh A.P., Uniyal P., Singh N.P., A find from the Ladakh Himalaya reveals a survival of madtsoiid snakes (Serpentes, Madtsoiidae) in India through the late Oligocene, Journal of Vertebrate Paleontology. [IF=2.19]"
        },
        {
          authors: "Mennecart B., Wazir W.A., Sehgal R.K., Patnaik R., Singh N.P., Kumar N., Nanda A.C., New remains of Nalamaeryx (Tragulidae, Mammalia) from the Ladakh Himalaya and their phylogenetical and palaeoenvironmental implications, Historical Biology. [IF=2.259]"
        },
        {
          authors: "Uniyal P., Sihota P., Kumar N., Effect of organic matrix alteration on strain rate dependent mechanical behaviour of cortical bone, Journal of the Mechanical Behavior of Biomedical Materials 125:104910. [IF=4.042]"
        },
        {
          authors: "Dwivedi K.K., Lakhani P., Kumar S., Kumar N., Effect of collagen fibre orientation on the Poisson’s ratio and stress relaxation of skin: an ex vivo and in vivo study, Royal Society Open Science 9(21):13012. [IF=2.963]"
        },
        {
          authors: "Dwivedi K.K., Lakhani P., Kumar S., Kumar N., A hyperelastic model to capture the mechanical behaviour and histological aspects of the soft tissues, Journal of Mechanical Behavior of Biomedical Materials 126:105013. [IF=4.042]"
        }
      ]
    },
    
     {
      year: 2023,
      publications: [
        {
          authors: "Pal S., Sharma S., Porwal K., Tiwari M.C., Khan Y.A., Kumar S., Kumar N., Chattopadhyay N., The Role of Osteogenic Effect and Vascular Function in Bone Health in Hypertensive Rats: A Study of Anti-hypertensive and Hemorheologic Drugs, Calcified Tissue International:1–15. [IF=4.2]"
        },
        {
          authors: "Uniyal P., Kaur S., Dhiman V., Bhadada S.K., Kumar N., Effect of inelastic deformation on strain rate-dependent mechanical behaviour of human cortical bone, Journal of Biomechanics 161:111853. [IF=2.789]"
        },
        {
          authors: "Jyoti J., Chauhan G.S., Yang S., Singh B.P., Kumar A., Kim K.H., Gu M., Kumar N., et al., Mechanical and electromagnetic response of carbon fiber reinforced epoxy polymer composites at different orientations, Polymer Composites. [IF=3.531]"
        },
        {
          authors: "Tomer P., Shroti G.K., Mohapatra S., Ghosh D., Jaiswal S., Garg D., Lahiri D., Kumar N., Khatri O.P., Hazra S., Fabrication of HA Nano-crystal Reinforced PHAs based composites for orthopedic fracture-fixing accessories using sustainable resources, Environment, Development and Sustainability:1–19. [IF=4.08]"
        },
        {
          authors: "Tiwari S., Kumar R., Tiwari A.K., Tripathi D., Yadav R.N., Kumar N., Ambwani S., Estimation of Lacunar Permeability in Anatomical Regions of Femoral Cortex: Endocortical Versus Periosteal, In Future Learning Aspects of Mechanical Engineering, Springer Nature Singapore:2–10."
        },
        {
          authors: "Ansari A.I., Sheikh N.A., Kumar N., Simulation and experimental energy absorption behavior of ABS-M30i-based three distinct lattice structures fabricated by polymer 3D printer, Journal of the Brazilian Society of Mechanical Sciences and Engineering 45(10):509. [IF=2.361]"
        },
        {
          authors: "Porwal K., Sharma S., Kumar S., Tomar M.S., Sadhukhan S., Rajput S., Kulkarni C., Shrivastava A., Kumar N., Chattopadhyay N., Hormonal and non-hormonal oral contraceptives given long-term to pubertal rats differently affect bone mass, quality and metabolism, Frontiers in Endocrinology 14:1233613. [IF=6.056]"
        },
        {
          authors: "Singh J., Sarna A.K., Kumar N., Sharma V., Driveline System Effects on Powertrain Mounting Optimization for Vibration Isolation under Actual Vehicle Conditions, SAE International Journal of Commercial Vehicles 16(02-16-04-0026). [IF=0.306]"
        },
        {
          authors: "Dewangan R., Kumar N., Triply Periodic Minimal Surface (TPMS) Metamaterial Exhibiting Simultaneously Superior Acoustic and Mechanical Energy Absorption Performance, In ISME Advances in Mechanical Engineering, Springer Nature Singapore:85–97."
        },
        {
          authors: "Jha A.K., Kumar N., Suresh K., Hybridisation effect of carboxyl graphene and silica nanofillers on environmentally aged composite acrylonitrile butadiene rubber, Journal of Rubber Research:1–16. [IF=1.208]"
        },
        {
          authors: "Haneef J., Markad D., Chadha R., Kumar A., Kumar N., Structural Insights Into Mechanical Anisotropy In Ambrisentan Polymorphs, CrystEngComm. [IF=3.756]"
        },
        {
          authors: "Ansari A.I., Sheikh N.A., Kumar N., Energy-Absorbing Characteristics of an ABS-M30i-based 3D-Printed Periodic Surface and Strut-Based Lattice Structure, Journal of The Institution of Engineers (India): Series C:1–16. [IF=0.349]"
        },
        {
          authors: "Raik S., Sharma P., Kumar S., Rattan V., Das A., Kumar N., Srinivasan R., Bhattacharyya S., Three-dimensional spheroid culture of dental pulp-derived stromal cells enhance their biological and regenerative properties for potential therapeutic applications, International Journal of Biochemistry & Cell Biology 160:106422. [IF=5.652]"
        },
        {
          authors: "Kulkarni C., Sharma S., Porwal K., Rajput S., Sadhukhan S., Singh V., Singh A., Baranwal S., Kumar S., Girme A., Pandey A.R., Singh S.P., Sashidhara K.V., Kumar N., Hingorani L., Chattopadhyay N., A standardized extract of Coleus forskohlii root protects rats from ovariectomy-induced loss of bone mass and strength, and impaired bone material by osteogenic and antiresorptive mechanism, Frontiers in Endocrinology. [IF=6.05]"
        },
        {
          authors: "Verma D., Chandran Y., Uniya P., Kumar N., Balakrishnan V., Multifold stiffness and fracture toughness enhancement in W doped VO2 microcrystals, Journal of the American Ceramic Society. [IF=4.186]"
        }
      ]
    },
    
{
      year: 2024,
      publications: [
        {
          authors: "Sihota P., Kumar S., Dhaliwal R., Uniyal P., Yadav R.N., Dhiman V., Neradi D., Bhadada S.K., Kumar N., et al., Multi-scale inferomedial femoral neck bone quality in type 2 diabetes patients with fragility fracture, Bone. [IF=3.5]"
        },
        {
          authors: "Singh S., Kumar N., Squeeze Film Damping Due to Flexible and Rigid Body Motion in MEMS: A Comparison of Analytical, Numerical and Experimental Results, Microsystem Technologies. [IF=1.6]"
        },
        {
          authors: "Singla J., Kumar N., Bansal A., Microstructural and mechanical properties of Al-5356 alloy structures fabricated using direct energy deposition (DED): In-pursuit to optimizing deposition parameters, Materials Characterization 216:114321. [IF=4.8]"
        },
        {
          authors: "Singh J., Sarna A.K., Kumar N., Sharma V., Effects of Multi-Drivelines System on Powertrain Mounting Design for Vibration Isolation in Real Vehicle Operating Conditions, Journal of Vibration Engineering & Technologies. [IF=2.1]"
        },
        {
          authors: "Avinash M., Kumar N., Production of Metallic Foam and its Behavior at Different Strain Rates: A Review, Journal of The Institution of Engineers (India): Series C. [IF=1.349]"
        },
        {
          authors: "Sarna A.K., Singh J., Kumar N., Sharma V., Unique Approach of Modern Automotive Exhaust System Mountings Design for NVH Improvement, SAE International Journal of Commercial Vehicles 17. [IF=0.6]"
        },
        {
          authors: "Ansari A.I., Sheikh N.A., Kumar N., Mechanical and in vitro study of 3D printed silk fibroin and bone-based composites biomaterials for bone implant application, Proceedings of the Institution of Mechanical Engineers, Part H: Journal of Engineering in Medicine. [IF=1.7]"
        },
        {
          authors: "Ansari A.I., Sheikh N.A., Kumar N., High strain rate testing of hybrid TPMS structures, Journal of the Brazilian Society of Mechanical Sciences and Engineering 46(7). [IF=1.8]"
        },
        {
          authors: "Ansari A.I., Sheikh N.A., Kumar N., Evaluation of the energy absorbing capacity of the two combinations of TPMS structure subjected to different compressive strain rates, Journal of the Brazilian Society of Mechanical Sciences and Engineering 46(6):334. [IF=2.2]"
        },
        {
          authors: "Thami T., Sharma S., Kumar A., Kumar N., Chauhan N., Aggarwal A., Dhillon M., Evaluation of the Stability of Internal Fixation Constructs in a Low Distal Tibia Extra-articular Cadaveric Fracture Model: A Comparative Biomechanical Study, Cureus 16(2). [IF=1.2]"
        },
        {
          authors: "Ansari A.I., Sheikh N.A., Kumar N., Visco-mechanical characterization of Molluscs (sea shell) biomimetics designs structures, Journal of the Brazilian Society of Mechanical Sciences and Engineering 46(5):326. [IF=2.2]"
        },
        {
          authors: "Sharma S., Kumar S., Tomar M.S., Chauhan D., Kulkarni C., Rajput S., Sadhukhan S., Kumar N., Chattopadhyay N., Multiscale effects of the calcimimetic drug, etelcalcetide on bone health of rats with secondary hyperparathyroidism induced by chronic kidney disease, Bone. [IF=4.15]"
        },
        {
          authors: "Barekar S.S., Sarawade S.S., Kumar N., A survey on the mechanical properties of bone, Multimedia Tools and Applications. [IF=3.6]"
        },
        {
          authors: "Ansari A.I., Sheikh N.A., Kumar N., Computational and experimental assessment of peacock feather, International Journal on Interactive Design and Manufacturing (IJIDeM). [IF=2.2]"
        },
        {
          authors: "Dwivedi K.K., Jhorar R., Kumar S., Kumar N., Mechanical Stimulation Alters the Collagen Protein Structure in Skin Tissue, In Microbiology-2.0 Update for a Sustainable Future, Springer Nature Singapore, 2024."
        },
        {
          authors: "Saxena S., Bhatia S., Kumar N., Fortifying Artificial Pancreas: A Hardware-in-the-Loop Simulation Study of Cyber-Attacks and Defense Mechanisms, In 2024 15th International Conference on Computing Communication and Networking Technologies (ICCCNT), IEEE, 2024."
        },
        {
          authors: "Sarna A.K., Singh J., Kumar N., Sharma V., Influence of Exhaust Aftertreatment System on Powertrain Vibration Behavior, SAE International Journal of Commercial Vehicles 17. [IF=1.2]"
        },
        {
          authors: "Ansari A.I., Sheikh N.A., Kumar N., High strain rate response of ABS-M30i-based 3D printed, bio-inspired, bovine bone structure, Proceedings of the Institution of Mechanical Engineers, Part L: Journal of Materials: Design and Applications. [IF=2.97]"
        },
        {
          authors: "Ansari A.I., Sheikh N.A., Kumar N., Nath J., Three-dimensional printed silk fibroin and fenugreek based bio-composites scaffolds, Proceedings of the Institution of Mechanical Engineers, Part L: Journal of Materials: Design and Applications."
        },
        {
          authors: "Mathew N.S., Devangan R., Kumar N., Alegaonkar P.S., Effect of Impulse Pressure on Diyl Diphenol Cross-Linked Polymer, In International Conference on Nanotechnology: Opportunities and Challenges, Springer Nature Singapore, 2022."
        },
        {
          authors: "Walenda M., Lektorov A., Saxena S., Bhatia S., Kumar N., SecAP: Security Analysis of the Artificial Pancreas, In 2023 International Conference on Computing, Communication, and Intelligent Systems (ICCCIS), IEEE."
        },
        {
          authors: "Uniyal P., Kumar N., Spataro M., Microstructural and dynamic mechanical behavior of the cortical bone, In Dynamic Mechanical and Creep-Recovery Behavior of Polymer-Based Composites, Elsevier, 2024."
        }
      ]
    },
    
    {
      year: 2025,
      publications: [
           {
          authors: "Rastogi, Ashu, Raveena Singh, Saroj Kumar, Srinivas Seshabhattaru, Rajesh Kesavan, Uttam Chand Saini, Navin Kumar, and Sanjay Kumar Bhadada. \"Hierarchical multimodal structural and material analysis of bone in diabetes.\" Translational Research (2025). [I.F =5.9]"
        },
        
        {
          authors: "Sandhu, Manjit, Navin Kumar, Ravinder Singh Sawhney, and Gagandeep Kaur. \"Intramedullary Nailing in Long Bone Fractures: A Review of Clinical Outcomes and Complications.\" In 2025 7th International Symposium on Advanced Electrical and Communication Technologies (ISAECT), pp. 1-8. IEEE, 2025."
        },
        
        {
          authors: "Sandhu, Manjit, Navin Kumar, Ravinder Singh Sawhney, Jeevan Jyoti, Kuldeep Singh,and Pawandeep Kaur. \"Ultimate biomaterial: titanium a gold standard choice for current orthopaedic implants.\" In Mechanics and Materials Science of Biological Materials: Experimental and Modeling Approaches, pp. 107-131. Singapore: Springer Nature Singapore, 2025."
        },
          {
          authors: "Sihota, Praveer, and Navin Kumar. \"Multiscale Assessment of Bone Fragility Beyond Bone Mineral Density.\" In Mechanics and Materials Science of Biological Materials: Experimental and Modeling Approaches, pp. 1-17. Singapore: Springer Nature Singapore, 2025."
        },
          {
          authors: "Lakhani, Piyush, and Navin Kumar. \"Investigating Mechanical Anisotropy of Excised Porcine Skin Using Dog-Bone Specimen.\" In Mechanics and Materials Science of Biological Materials: Experimental and Modeling Approaches, pp. 163-179. Singapore: Springer Nature Singapore, 2025."
        },
  {
          authors: "Dwivedi, Krashn Kumar, Sachin Kumar, and Navin Kumar. \"Experimental Technique and Constitutive Models for Skin Tissue: A Review.\" Mechanics and Materials Science of Biological Materials: Experimental and Modeling Approaches (2025): 31-46."
        },
  {
          authors: "Kiran, Abhimanyu, Navin Kumar, and Vishwajeet Mehandia. \"A Review on Mechanismsof Single-Cell and Collective Cell Migration: Insights into Tissue Dynamics.\" Mechanics and Materials Science of Biological Materials: Experimental and Modeling Approaches (2025): 145-161."
        },
       
       
      
     

        {
          authors: "Singla J., Kumar N., Bansal A., Manufacturing of Ti6Al4V alloy using argon chamber assisted WAAM-CMT to avoid oxidation and analyses of mechanical and metallurgical properties, Journal of Alloys and Compounds 1038:182950. [IF=6.37]"
        },
        {
          authors: "Singh S., Kumar V., Kumar N., Investigation of a novel symmetric-structure based MEMS piezoresistive accelerometer, IEEE Transactions on Components, Packaging and Manufacturing Technology. [IF=2.3]"
        },
        {
          authors: "Singla J., Kumar N., Bansal A., Singla A.K., Khanna N., Fabrication of Ti6Al4V alloy by Wire Arc Additive Manufacturing Process and Comprehensive Machinability Analysis, Wear. [IF=6.1]"
        },
        {
          authors: "Sandhu M., Kumar N., Sawhney R.S., Orthopaedic implants-Ti based bio materials, In AIP Conference Proceedings 3261(1):160002, AIP Publishing LLC."
        },
        {
          authors: "Avinash M., Mohammad, Kumar N., Effect of Struts Arrangements on Lattice Structures: Experimental and Numerical Approach, Mechanics of Solids. [2025]"
        },
        {
          authors: "Avinash M., Mohammad, Kumar N., Experimental and Numerical Investigation on Compressive Behavior of Polymeric Cell Foam Structures, Journal of The Institution of Engineers (India): Series C. [2025]"
        },
        {
          authors: "Chauhan N., Kumar S., Thami T., Kumar N., Prabhakar S., Dhillon M., Sharma S., Effect of Distal Fragment Length on Construct Stability in an Extra-articular Distal Tibial Fracture Model Fixed With Locked Intramedullary Nailing: A Biomechanical Study, Cureus 17(5):e83355. [IF=1.2]"
        },
        {
          authors: "Sharma S., Khing J., Kumar N., Naresh R., Sihota P., Dhillon M.S., Aggarwal S., Sudesh P., Can Intermittent Teriparatide Facilitate Supraphysiological-Rate Distraction Osteogenesis? A Feasibility Study in the Rabbit Tibial Lengthening Model, Indian Journal of Orthopaedics. [IF=1.2]"
        },
        {
          authors: "Kulkarni C., Kumar S., Khatoon S., Sadhukhan S., Washimkar K.R., Kumar A., Sharma S., Kumar N., et al., Isovitexin, a natural adiponectin agonist, prevents glucocorticoid-induced osteosarcopenia, Endocrine. [IF=3.1]"
        },
        {
          authors: "Raik S., Kaur B., Kumar S., Rattan V., Kumar N., Bhattacharyya S., Secretome Derived From Mesenchymal Stem Cells Cultured as Monolayer Show Enhanced Bone Regeneration Compared to Secretome From 3D Spheroid-Clues From the Proteome, Advanced Healthcare Materials:e2500885. [IF=10]"
        },
        {
          authors: "Kurup A.M., Bhushan R.K., Kumar N., Kumar N., Sen R.K., Assessment of the Effects of Core Decompression on the Patho-Biomechanics of the Femoral Head in Avascular Necrosis: A Biomechanical Perspective, Injury:112350. [IF=2.2]"
        },
        {
          authors: "Singh S., Kumar V., Singh S.P., Kumar N., Investigation of gold-silicon eutectic bonding to realize the symmetric sensing element of MEMS piezoresistive accelerometer, IEEE Transactions on Components, Packaging and Manufacturing Technology. [IF=2.3]"
        },
        {
          authors: "Sharma S., Kumar S., Tomar M.S., Chauhan D., Sadhukhan S., Kulkarni C., Rajput S., Kumar N., Chattopadhyay N., et al., Multifaceted skeletal effects of sevelamer carbonate in a secondary hyperparathyroidism model, Endocrine. [IF=3.1]"
        },
        {
          authors: "Saini R., Goswami R.N., Sharma O.P., Singh R., Kumar A., Kumar N., Khatri O.P., Graphene–Nickel Oxide–Polyaniline Ternary Nanocomposite‐Embedded Epoxy Coating on Mild Steel for Corrosion Protection, Advanced Engineering Materials:2402332. [IF=3.4]"
        },
       
      ]
    },{
      year: 2026,
      publications: [
         {authors:"Jyoti, Jeevan, Amit Kumar, Gaurav Singh Chauhan, Sangita Tripathy, Bhanu Pratap Singh, Ki Hyeon Kim, Navin Kumar, and S. K. Tripathi. \"Synergistic Effect of Sandwich Layer of Carbon Nanotube Bucky Paper in Carbon Fiber Reinforced Hybrid Laminated Composite for High‐Performance Mechanical and Electromagnetic Interference Shielding.\" Polymer Composites (2026). [I.F = 6.01]"},
          {authors:"Saxena, Sahaj, and Navin Kumar. \"Safe Glucose Regulation in Artificial Pancreas Systems via Robust Control Barrier Functions.\" Transactions of the Institute of Measurement and Control (2025): 01423312251405018. [I.F = 1.7 ]"},
        {
          authors: "Pandey, Sarita, Saroj Kumar, Madhu Gupta, Shweta Shukla, Ramesh Chaurasiya, Hina Masroor, Aditi Singh, Navin Kumar, and Md Arshad. \"Progressive impact of polycystic ovary syndrome on hormonal alterations, bone microarchitecture, and mechanical properties.\" Journal of Endocrinology 268, no. 1 (2026). [I.F = 3.9]"
        },
       
       
      ]
    }
  
    ];

  const totalPublications = publications.reduce(
    (total, year) => total + year.publications.length,
    0
  );

  // Step 2: Create a counter starting from total
  let count = totalPublications;

  return (
    <div className="min-h-screen overflow-x-auto p-4 font-serif">
      <h2 className="text-3xl p-4 font-semibold">Patents:</h2>
      <table className="min-w-full bg-white ">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 border-b">S.No.</th>
            <th className="px-4 py-2 border-b">Authors</th>
            <th className="px-4 py-2 border-b">Titles</th>
            <th className="px-4 py-2 border-b">Application No.</th>
            <th className="px-4 py-2 border-b">Status</th>
          </tr>
        </thead>
        <tbody>
          {patents.map((patents, index) => (
            <tr key={index} className="bg-gray-100">
              <td className="px-4 py-2  text-center">{index+1}</td>
              <td className="px-4 py-2 border-b">{patents.authors}</td>
              <td className="px-4 py-2 border-b">{patents.title}</td>
              <td className="px-4 py-2 border-b">{patents.applicationsNo}</td>
              <td className="px-4 py-2 border-b text-center">{patents.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <h2 className="text-3xl p-4 font-semibold">Papers:</h2>

      <div>

        {publications.slice().reverse().map((yearEntry) => (
          <div key={yearEntry.year}>
            <p className="text-2xl bg-gray-800 py-3 px-8 rounded-full text-white mt-4 w-max">
              {yearEntry.year}
            </p>
            <ul className="mt-4">
              {yearEntry.publications.map((pub) => (
                <li key={count}>
                  <div className="flex items-start space-x-2">
                    <span className="font-bold">{count--}.</span>
                    <span>{pub.authors}</span>
                  </div>
                  <br />
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

    </div>
  );
}

export default Publications;